var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "styled-components";
import { BaseInput, BaseInputButton, BaseInputContainer, BaseInputLabel, } from "../../designSystem";
var Container = styled.div.attrs({
    className: "d-flex flex-column flex-grow-1",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var InputContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var InputContainer = styled(BaseInputContainer).attrs({
    className: "d-flex flex-row flex-grow-1",
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 10px 0;\n  margin-top: 0;\n"], ["\n  padding: 10px 0;\n  margin-top: 0;\n"])));
var Input = styled(BaseInput)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var LabelContainer = styled.div.attrs({
    className: "d-flex align-items-center",
})(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var InsideInputLabel = styled(BaseInputLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 0 8px;\n"], ["\n  padding: 0 8px;\n"])));
var BasicInput = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "s" : _b, rightButtonProps = _a.rightButtonProps, inputProps = _a.inputProps, labelProps = _a.labelProps, leftContent = _a.leftContent;
    var sizeSpecificProps = useMemo(function () {
        var props = {
            containerHeight: "48px",
            fontSize: "16px",
            lineHeight: 24,
        };
        switch (size) {
            case "xs":
                props.containerHeight = "48px";
                props.fontSize = "16px";
                props.lineHeight = 24;
                break;
            case "s":
                props.containerHeight = "64px";
                props.fontSize = "22px";
                props.lineHeight = 28;
                break;
            default:
                props.containerHeight = "64px";
                props.fontSize = "22px";
                props.lineHeight = 28;
                break;
        }
        return props;
    }, [size]);
    var inputStyles = useMemo(function () {
        var style = __assign({ fontSize: sizeSpecificProps.fontSize }, inputProps.style);
        if (labelProps.isInside) {
            style.padding = "0 8px";
            style.height = "auto";
        }
        return style;
    }, [sizeSpecificProps, inputProps, labelProps]);
    return (_jsxs(Container, { children: [!labelProps.isInside && (_jsxs(LabelContainer, { children: [_jsx(BaseInputLabel, { children: labelProps.text }, void 0), labelProps.accessoryComponent && labelProps.accessoryComponent] }, void 0)), _jsxs(InputContainer, __assign({ style: {
                    height: sizeSpecificProps.containerHeight,
                }, error: !!inputProps.error }, { children: [leftContent, _jsxs(InputContent, { children: [labelProps.isInside && (_jsxs(LabelContainer, { children: [_jsx(InsideInputLabel, { children: labelProps.text }, void 0), labelProps.accessoryComponent && labelProps.accessoryComponent] }, void 0)), _jsx(Input, __assign({ type: "number", className: "form-control" }, inputProps, { style: inputStyles, lineHeight: sizeSpecificProps.lineHeight }), void 0), rightButtonProps && (_jsx(BaseInputButton, __assign({ onClick: rightButtonProps.onClick }, { children: rightButtonProps.text }), void 0))] }, void 0)] }), void 0)] }, void 0));
};
export default BasicInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=BasicInput.js.map